<template>
  <div class="page">
    <div class="tabs-card">
      <a-tabs v-model:activeKey="tab" @tabClick="tabChange">
        <template #leftExtra>
          <div class="goback" @click="goBack">
            <left-outlined class="outlined f-w-b" />
            <!-- <span style="margin-left: 4px" class="">返回</span> -->
          </div>
        </template>
        <a-tab-pane key="1" tab="基本信息">
          <div :style="{ height: scollHeigth + 'px' }" class="info">
            <div class="top">
              <div class="image">
                <a-upload :action="action" :before-upload="beforeUpload" :data="formData" :headers="header" :show-upload-list="false" class="avatar-uploader" name="image" @change="handleChange">
                  <img
                    :src="imgCut(detailsData.image ? detailsData.image : companyLogo, 'xl')"
                    alt="房源图片"
                    fit="fill"
                    style="width: 120px; height: 80px; object-fit: cover; cursor: pointer; border-radius: 5px"
                  />
                </a-upload>
                <div class="hint f-12">点击更换封面</div>
              </div>
              <div class="title">
                <div class="f-w-b f-c-000">
                  <div class="editable-cell">
                    <div v-if="editTitle" class="editable-cell-input-wrapper">
                      <a-input v-model:value="detailsData.name" :maxlength="15"></a-input>
                      <check-circle-outlined class="editable-cell-icon-check f-16" @click="editSave()" />
                    </div>
                    <div v-else class="editable-cell-text-wrapper f-16">
                      {{ detailsData.name }}
                      <form-outlined class="f-c-999 editable-cell-icon" style="cursor: pointer" @click="editTitle = true" />
                    </div>
                  </div>
                </div>
                <!-- <div class="f-c-999">库存：接口没给</div> -->
              </div>
              <div class="btn">
                <a-button @click="delHouse()">移除房型</a-button>
              </div>
            </div>
            <div class="con">
              <div class="card-container">
                <a-tabs v-model:activeKey="activeKey" type="card" @tabClick="tabToChange">
                  <a-tab-pane :key="1" tab="价格设置">
                    <div :style="{ height: scollHeigth - 200 + 'px' }" class="card-box">
                      <div class="card-con">
                        <a-form ref="baseFormRef" :label-col="{ span: 5 }" :model="detailsData" :rules="baseFormRules" hideRequiredMark labelAlign="left">
                          <a-form-item label="周日-周四价：" name="sun_to_thur">
                            <a-input v-model:value="detailsData.sun_to_thur" placeholder="请输入周日-周四价" style="width: 100%" />
                          </a-form-item>
                          <a-form-item label="周五-周六价：" name="fri_to_sat">
                            <a-input v-model:value="detailsData.fri_to_sat" placeholder="请输入周五-周六价" style="width: 100%" />
                          </a-form-item>
                          <a-form-item label="节假日价：" name="holiday">
                            <a-input v-model:value="detailsData.holiday" placeholder="请输入节假日价" style="width: 100%" />
                          </a-form-item>
                          <a-form-item label="是否覆盖日历价：">
                            <a-switch v-model:checked="detailsData.is_calendar_update" checked-children="是" checkedValue="1" un-checked-children="否" unCheckedValue="0" />
                          </a-form-item>
                          <div class="operate">
                            <a-button class="btn-primary" @click="savePriceSet">保存 </a-button>
                          </div>
                        </a-form>
                      </div>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane :key="2" tab="关联房间">
                    <div :style="{ height: scollHeigth - 200 + 'px' }" class="card-con">
                      <div class="add-btn">
                        <a-button class="btn-primary" @click="handleRelehouse">关联房间 </a-button>
                      </div>

                      <div v-if="relationList.length" class="house-list">
                        <div v-for="(item, index) in relationList" :key="index" class="house-one">
                          <div class="house-image">
                            <img :src="imgCut(item.image ? item.image : companyLogo, 'xl')" alt="房源图片" fit="fill" style="width: 80px; height: 60px; object-fit: cover; border-radius: 5px" />
                          </div>
                          <div class="house-name f-w-b">
                            {{ item.name }}
                          </div>
                          <div class="cancel" @click="cancelRel(item)">
                            <close-circle-outlined class="f-c-red" />
                          </div>
                        </div>
                      </div>
                      <div v-else class="empty-box">
                        <a-empty :image="simpleImage">
                          <template #description>
                            <span>
                              该房型下暂无房间，这会导致有订单时无法自动排房
                              <br />
                              请在左上角添加房型包含的房间
                            </span>
                          </template>
                        </a-empty>
                      </div>
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="房态日历">
          <!-- <div class="empty" :style="{ height: scollHeigth + 'px' }" v-else>
            <a-spin size="large" />
          </div> -->
        </a-tab-pane>
        <a-tab-pane key="3" tab="房价日历">
          <div class="price-top">
            <a-select v-model:value="ota_house_id" :dropdownMatchSelectWidth="false" allowClear placeholder="渠道" @change="handleChangeOtaPrice">
              <a-select-option v-for="(item, index) in channelList" :key="index" :value="item.ota_house_id">{{ item.cname }}{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div v-if="!searchLoading" :style="{ height: scollHeigth - 37 + 'px' }" class="calendar">
            <div v-for="(items, indexs) in priceData" :key="indexs" class="mon-box" style="overflow-anchor: auto">
              <div class="month">
                {{ items.date }}
              </div>
              <div class="week">
                <div class="f-c-red">周日</div>
                <div>周一</div>
                <div>周二</div>
                <div>周三</div>
                <div>周四</div>
                <div>周五</div>
                <div class="f-c-red">周六</div>
              </div>
              <div class="day-box">
                <div
                  v-for="(item, index) in priceData[indexs].list"
                  :key="index"
                  :class="{
                    pitchOn: pitchOnData.date.includes(item.date),
                    pitchOnRange: isRangePitchOn(item),
                    hoverBox: isPriceHover(item),
                  }"
                  :style="{ backgroundColor: handleBgc(item) }"
                  class="one-box"
                  @click="pitchOnday(items, index)"
                >
                  <!-- 有订单日期背景 -->
                  <div v-if="item.status == 2" :style="{ backgroundColor: handleBgc(item) }" class="disabled">
                    <MyIcon type="icon-pms_order_house" />
                  </div>
                  <!-- 关房日期背景 -->
                  <div v-else-if="item.status == 3" :style="{ backgroundColor: handleBgc(item) }" class="disabled">
                    <MyIcon type="icon-pms_lock_house" />
                  </div>
                  <!-- 禁选日期背景 -->
                  <div v-else-if="isPassday(item)" :style="{ backgroundColor: handleBgc(item) }" class="disabled">
                    <MyIcon type="icon-pms_disable_house" />
                  </div>

                  <div v-if="isToday(item)" class="day f-c-green">今天</div>
                  <div v-else :class="{ f999: isPastDate(item) }" class="day">
                    {{ item.day }}
                  </div>
                  <div :class="{ f999: isPastDate(item) }" class="price f-16">
                    {{ item.price }}
                  </div>
                  <div v-if="item.is_holiday" class="tips-rig">休</div>
                  <div v-if="item.holidaytag" class="tips-lef f-c-red">
                    {{ item.holidaytag }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else :style="{ height: scollHeigth + 'px' }" class="empty">
            <a-spin size="large" />
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" tab="渠道管理">
          <div :style="{ height: scollHeigth + 'px' }" class="channel">
            <div v-if="bandChannelHouseList.length" class="status f-c-999">已关联</div>
            <div class="channel-list">
              <div v-for="(item, index) in bandChannelHouseList" :key="index" class="channel-list-box">
                <div class="name">
                  <div class="logo">
                    <a-avatar :size="30" :src="imgCut(item.ota_logo, 'xl')" style="width: 30px"></a-avatar>
                  </div>
                  <div class="channel-name">
                    <div class="f-18 f-w-b">{{ item.ota_name }}</div>
                    <div class="introduce f-12 f-c-999">
                      {{ item.ota_describe }}
                    </div>
                  </div>
                </div>

                <div class="house">
                  <div class="image">
                    <img
                      :src="imgCut(item.head_url ? item.head_url : item.ota_logo, 'xl')"
                      alt="房源图片"
                      fit="fill"
                      style="width: 80px; height: 60px; object-fit: cover; cursor: pointer; border-radius: 5px"
                    />
                  </div>
                  <div class="info">
                    <div class="hname">{{ item.title }}</div>
                    <div class="account f-c-999">{{ item.ota_name }}-{{ item.name }}</div>
                  </div>
                </div>
                <div class="operate">
                  <div class="rig">
                    <!-- <a-button @click="saveStatus" class="m-l">上架</a-button>
                    <a-button @click="saveStatus" class="m-l">下架</a-button> -->
                    <a-button class="m-l" @click="unBingChannel(item)">解除关联 </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="unBandChannelList.length" class="status f-c-999">未关联</div>
            <div class="channel-list">
              <div v-for="(item, index) in unBandChannelList" :key="index" class="channel-list-box">
                <div class="name">
                  <div class="logo">
                    <a-avatar :size="30" :src="imgCut(item.ota_logo, 'xl')" style="width: 30px"></a-avatar>
                  </div>
                  <div class="channel-name">
                    <div class="f-18 f-w-b">{{ item.ota_name }}-{{ item.name }}</div>
                    <div class="introduce f-12 f-c-999">
                      {{ item.ota_describe }}
                    </div>
                  </div>
                </div>
                <div class="operate">
                  <div class="rig">
                    <a-button class="m-l" @click="goRouter('/pms/landlord/rela')">关联 </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="unUseChannelList.length" class="status f-c-999">未启用</div>
            <div class="channel-list">
              <div v-for="(item, index) in unUseChannelList" :key="index" class="channel-list-box">
                <div class="name">
                  <div class="logo">
                    <a-avatar :size="30" :src="imgCut(item.logo, 'xl')" style="width: 30px"></a-avatar>
                  </div>
                  <div class="channel-name">
                    <div class="f-18 f-w-b">{{ item.name }}</div>
                    <div class="introduce f-12 f-c-999">
                      {{ item.describe }}
                    </div>
                  </div>
                </div>
                <div class="operate">
                  <div class="rig">
                    <a-button class="m-l" @click="goRouter('/pms/landlord/ota/account')">去添加 </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>

    <!-- 批量改价 -->
    <AmendPrice
      v-if="visiblePrice"
      :priceDate="[dayjs(pitchOnData.date[0]), dayjs(pitchOnData.date[1])]"
      :rid="detailsData.id"
      :type="1"
      @changeDate="priceDateChange"
      @closeAmendPrice="visiblePrice = false"
      @refreshAmendPrice="
        visiblePrice = false;
        handleChangeOtaPrice(ota_house_id);
      "
    />

    <!-- 关联房间 -->
    <a-modal v-model:visible="visibleRele" :width="980" title="关联房间" @ok="releSave">
      <div v-if="unrelationList.length" class="house-list">
        <div v-for="(item, index) in unrelationList" :key="index" class="house-one" style="padding: 10px; align-items: center" @click="item.checked = !item.checked">
          <div class="house-image">
            <img :src="imgCut(item.image ? item.image : companyLogo, 'xl')" alt="房源图片" fit="fill" style="width: 80px; height: 60px; object-fit: cover; border-radius: 5px" />
          </div>
          <div class="house-name f-w-b">
            {{ item.name }}
          </div>
          <div class="cancel">
            <a-checkbox v-model:checked="item.checked"></a-checkbox>
          </div>
        </div>
      </div>
      <div v-else class="empty-box">
        <a-empty :image="simpleImage">
          <template #description>
            <span> 该房型下暂无房间可以关联 </span>
          </template>
        </a-empty>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { createVNode, nextTick, onMounted, reactive, ref, toRefs } from 'vue';
import router from '@/router/index';
import {
  getRoomDetails,
  getRoomShutOtaCom,
  houseRelation,
  HouseStatusCale,
  otaDelHouseRela,
  otaGetAllOtaList,
  otaGetCale,
  otaGetOtaRoomList,
  otaGetRelatOtaCom,
  relationHouse,
  roomCancel,
  roomDel,
  roomEdit,
  roomGetcalendarprice,
} from '@/api/api';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index';
import { CheckCircleOutlined, CloseCircleOutlined, createFromIconfontCN, ExclamationCircleOutlined, FormOutlined, LeftOutlined } from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import { Empty, message, Modal } from 'ant-design-vue';
import { verifyPrice } from '@/common/validator';
import AmendPrice from '../../../../components/pms/landlord/AmendPrice/AmendPrice.vue';
import { baseRequestUrl } from '../../../../config.js';

const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2843326_ehl92hj8nzo.js',
});

export default {
  components: {
    FormOutlined,
    CheckCircleOutlined,
    LeftOutlined,
    CloseCircleOutlined,
    AmendPrice,
    MyIcon,
  },
  setup() {
    let { imgCut } = useUtils();
    // 标签
    const tab = reactive({
      tab: 1,
      activeKey: 1,
      tabChange(e) {
        houseStatus.pitchOnData.date = [];
        houseStatus.pitchOnData.week_e = '';
        houseStatus.pitchOnData.week_s = '';
        housePrice.visiblePrice = false;

        if (e == 2) {
          // houseStatus.getStatusData();
        } else if (e == 3) {
          housePrice.getPriceData();
          housePrice.getchannelList();
        } else {
          channel.getBandChannelHouse();
          channel.getunBandChannel();
          channel.getunUseChannel();
        }
      },
      tabToChange(e) {
        if (e == 1) {
          console.log('e');
        } else if (e == 2) {
          tab.getHouseList(1);
        }
      },
      relationList: [],
      unrelationList: [],
      getHouseList(type) {
        relationHouse({
          start: 0,
          limit: 999,
          rid: details.rid,
          type: type,
        }).then(res => {
          if (type == 1) {
            tab.relationList = res.data.list;
          } else {
            tab.unrelationList = res.data.list;
          }
        });
      },
      goBack() {
        router.go(-1);
      },
      goRouter(url) {
        router.push(url);
      },
    });
    let searchLoading = ref(false);
    let scollHeigth = store.state.ContentHeight - 90;

    //  详情数据
    const details = reactive({
      detailsData: {},
      baseFormRef: '',
      rid: router.currentRoute.value.query.rid,
      title: '',
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      baseFormRules: {
        sun_to_thur: [
          {
            required: true,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
        fri_to_sat: [
          {
            required: true,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
        holiday: [
          {
            required: true,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
      },
      getDetailsData() {
        getRoomDetails({
          rid: details.rid,
        }).then(res => {
          details.detailsData = res.data;
          if (router.currentRoute.value.query.tab) {
            nextTick(() => {
              tab.tab = router.currentRoute.value.query.tab;
              tab.tabChange(tab.tab);
            });
          }
        });
      },
      editTitle: false,
      cancelRel(item) {
        roomCancel({
          rid: details.rid,
          hid: item.id,
        }).then(res => {
          message.success(res.msg);
          tab.getHouseList(1);
        });
      },
      editSave() {
        roomEdit({
          rid: details.rid,
          name: details.detailsData.name,
        }).then(res => {
          message.success(res.msg);
          details.editTitle = false;
        });
      },
      delHouse() {
        Modal.confirm({
          title: '确定移除此房型？',
          content: '房型移除后渠道房源将解除关联',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            roomDel({ rid: details.rid }).then(res => {
              message.success(res.msg);
              router.go(-1);
            });
          },
        });
      },
      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },
      handleChange(info) {
        if (info.file.status === 'done') {
          roomEdit({
            rid: details.rid,
            image: info.file.response.data.url,
          }).then(res => {
            message.success(res.msg);
            details.detailsData.image = info.file.response.data.url;
          });
        }
      },
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('只能上传jpg、png格式图片!');
        }
        return isJpgOrPng;
      },
      savePriceSet() {
        details.baseFormRef.validate().then(() => {
          let price_room = {
            sun_to_thur: details.detailsData.sun_to_thur,
            fri_to_sat: details.detailsData.fri_to_sat,
            holiday: details.detailsData.holiday,
          };
          roomEdit({
            is_calendar_update: details.detailsData.is_calendar_update,
            rid: details.rid,
            price_room: JSON.stringify(price_room),
          }).then(res => {
            message.success(res.msg);
            details.getDetailsData();
          });
        });
      },
    });

    // 关联房间
    const releHouse = reactive({
      visibleRele: false,
      handleRelehouse() {
        releHouse.visibleRele = true;
        tab.getHouseList(2);
      },
      releSave() {
        let hid_arr = [];
        for (let item of tab.unrelationList) {
          if (item.checked) {
            hid_arr.push(item.id);
          }
        }
        houseRelation({
          rid: details.rid,
          hid_arr: hid_arr.toString(),
        }).then(res => {
          message.success(res.msg);
          releHouse.visibleRele = false;
          tab.getHouseList(1);
        });
      },
    });

    // 房态日历
    const houseStatus = reactive({
      statusData: [],
      today: dayjs().format('YYYY-MM-DD'),
      pitchOnData: {
        date: [],
        price: '',
      }, //选中日期数据
      pitchOnOrder: {}, //选中订单数据
      // 判断是否为往日日期
      isPassday(e) {
        if (!e.day || new Date(e.date).getTime() == dayjs(houseStatus.today).valueOf() || new Date(e.date).getTime() > dayjs(houseStatus.today).valueOf()) {
          return false;
        } else {
          if (e.status == 2) {
            return false;
          } else {
            return true;
          }
        }
      },
      // 判断是否为今天日期
      isToday(e) {
        if (dayjs(e.date).valueOf() == dayjs(houseStatus.today).valueOf()) {
          return true;
        } else {
          return false;
        }
      },
      // 判断是否是之前的日期
      isPastDate(e) {
        if (dayjs(e.date).valueOf() < dayjs(houseStatus.today).valueOf() && !e.order?.id) {
          return true;
        } else {
          return false;
        }
      },
      // 房态——判断是否hover
      isStatusHover(e) {
        if (e.date) {
          if (dayjs(e.date).valueOf() >= dayjs(houseStatus.today).valueOf() || e.order?.id) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      // 房态——判断是否选中订单
      isRangePitchOn(e) {
        if (new Date(houseStatus.pitchOnData.date[0]).getTime() < new Date(e.date).getTime() && new Date(e.date).getTime() < new Date(houseStatus.pitchOnData.date[1]).getTime()) {
          return true;
        } else {
          return false;
        }
      },
      // 房态——判断订单的结束日期
      isOrderEnd(e) {
        if (new Date(e.date).getTime() == (e.order.checkout_time ? new Date(e.order.checkout_time).getTime() - 86400000 : new Date(e.order.end_date).getTime() - 86400000)) {
          return true;
        } else {
          return false;
        }
      },
      // 房态——判断订单的开始日期
      isOrderStart(e) {
        if (new Date(e.date).getTime() == new Date(e.order.start_date).getTime()) {
          return true;
        } else {
          return false;
        }
      },
      // 选中日期
      pitchOnday(s, i) {
        // 选中无订单
        if (!s.list[i].order?.id) {
          if (!s.list[i].day || new Date(s.list[i].date).getTime() == dayjs(houseStatus.today).valueOf() || new Date(s.list[i].date).getTime() > dayjs(houseStatus.today).valueOf()) {
            if (s.list[i].day) {
              // 房价日期操作
              if (tab.tab == 3) {
                if (houseStatus.pitchOnData.date.includes(s.list[i].date)) {
                  houseStatus.pitchOnData.date.push(s.list[i].date);
                  houseStatus.pitchOnData.week_e = s.list[i].week;
                  housePrice.visiblePrice = true;
                } else {
                  // 如果未选中
                  if (houseStatus.pitchOnData.date.length < 2) {
                    if (houseStatus.pitchOnData.date.length == 1) {
                      // 判断离店时间是否大于入住时间
                      if (new Date(houseStatus.pitchOnData.date[0]).getTime() <= new Date(s.list[i].date).getTime()) {
                        // s.list[i].ispitchOn = 1;
                        houseStatus.pitchOnData.date.push(s.list[i].date);
                        houseStatus.pitchOnData.week_e = s.list[i].week;
                      } else {
                        houseStatus.pitchOnData.date = [];
                        houseStatus.pitchOnData.week_e = '';
                        houseStatus.pitchOnData.week_s = '';
                        nextTick(() => {
                          houseStatus.pitchOnData.date.push(s.list[i].date);
                          houseStatus.pitchOnData.week_s = s.list[i].week;
                        });
                      }
                      housePrice.visiblePrice = false;
                    } else if (houseStatus.pitchOnData.date.length == 0) {
                      // s.list[i].ispitchOn = 1;
                      houseStatus.pitchOnData.date.push(s.list[i].date);
                      houseStatus.pitchOnData.week_s = s.list[i].week;
                    }
                    // 选中两个,则显示popup弹窗
                    if (houseStatus.pitchOnData.date.length == 2) {
                      housePrice.visiblePrice = true;
                    }
                  } else {
                    houseStatus.pitchOnData.date = [];
                    houseStatus.pitchOnData.week_e = '';
                    houseStatus.pitchOnData.week_s = '';
                    housePrice.visiblePrice = false;
                    nextTick(() => {
                      houseStatus.pitchOnData.date.push(s.list[i].date);
                      houseStatus.pitchOnData.week_s = s.list[i].week;
                    });
                  }
                }
              }

              // 房态日期操作
              if (tab.tab == 2) {
                if (houseStatus.pitchOnData.date.includes(s.list[i].date)) {
                  houseStatus.pitchOnData.date.push(s.list[i].date);
                  houseStatus.pitchOnData.week_e = s.list[i].week;
                  // housePrice.visiblePrice = true;
                } else {
                  // 如果未选中
                  if (houseStatus.pitchOnData.date.length < 2) {
                    if (houseStatus.pitchOnData.date.length == 1) {
                      // 判断离店时间是否大于入住时间
                      if (new Date(houseStatus.pitchOnData.date[0]).getTime() <= new Date(s.list[i].date).getTime()) {
                        // 判断是否日期范围内有订单
                        for (let g in houseStatus.statusData) {
                          for (let item of houseStatus.statusData[g].list) {
                            if (new Date(houseStatus.pitchOnData.date[0]).getTime() < new Date(item.date).getTime() && new Date(item.date).getTime() < new Date(s.list[i].date).getTime()) {
                              if (item.order?.id) {
                                houseStatus.pitchOnData.date = [];
                                houseStatus.pitchOnData.week_e = '';
                                houseStatus.pitchOnData.week_s = '';
                                message.warn('日期已占用');
                                return false;
                              }
                            }
                          }
                        }
                        // s.list[i].ispitchOn = 1;
                        houseStatus.pitchOnData.date.push(s.list[i].date);
                        houseStatus.pitchOnData.week_e = s.list[i].week;
                      } else {
                        houseStatus.pitchOnData.date = [];
                        houseStatus.pitchOnData.week_e = '';
                        houseStatus.pitchOnData.week_s = '';
                        nextTick(() => {
                          houseStatus.pitchOnData.date.push(s.list[i].date);
                          houseStatus.pitchOnData.week_s = s.list[i].week;
                        });
                      }
                    } else if (houseStatus.pitchOnData.date.length == 0) {
                      // s.list[i].ispitchOn = 1;
                      houseStatus.pitchOnData.date.push(s.list[i].date);
                      houseStatus.pitchOnData.week_s = s.list[i].week;
                    }
                    // 选中两个,则显示popup弹窗
                    if (houseStatus.pitchOnData.date.length == 2) {
                      // housePrice.visiblePrice = true;
                    }
                  } else {
                    houseStatus.pitchOnData.date = [];
                    houseStatus.pitchOnData.week_e = '';
                    houseStatus.pitchOnData.week_s = '';
                    nextTick(() => {
                      houseStatus.pitchOnData.date.push(s.list[i].date);
                      houseStatus.pitchOnData.week_s = s.list[i].week;
                    });
                  }
                }
              }
            }
          }
        } else {
          houseStatus.pitchOnOrder = s.list[i].order;
        }
      },
      getStatusData() {
        searchLoading.value = true;
        HouseStatusCale({
          hid: details.hid,
          date: dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          month: 15,
        }).then(res => {
          searchLoading.value = false;
          for (let item of res.data) {
            for (let s = item.list[0].week; s > 0; s--) {
              item.list.unshift({
                day: '',
                parice: '',
              });
            }
          }
          houseStatus.statusData = res.data;
        });
      },
    });

    // 房价日历
    const housePrice = reactive({
      priceData: [],
      channelList: [],
      ota_house_id: [],
      priceDateChange(params) {
        houseStatus.pitchOnData.date[0] = params[0];
        houseStatus.pitchOnData.date[1] = params[params.length - 1];
      },
      // 房价返回背景颜色
      handleBgc(item) {
        if (houseStatus.isPassday(item)) {
          return '#f0f0f0';
        } else if (item.status == 2 && !item.order) {
          return '#def5ff';
        } else if (item.status == 3) {
          return '#fdeaec';
        }
      },
      getchannelList() {
        getRoomShutOtaCom({
          rids: details.rid,
          start: 0,
          limit: 999,
        }).then(res => {
          housePrice.channelList = res.data.list[0].ota_com;
        });
      },
      getPriceData() {
        if (housePrice.priceData.length == 0) {
          searchLoading.value = true;
        }
        roomGetcalendarprice({
          rid: details.rid,
          date: dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          month: 15,
        }).then(res => {
          searchLoading.value = false;
          for (let item of res.data) {
            for (let s = item.list[0].week; s > 0; s--) {
              item.list.unshift({
                day: '',
                parice: '',
              });
            }
          }
          housePrice.priceData = res.data;
        });
      },
      // 房价——判断是否hover
      isPriceHover(e) {
        if (e.date) {
          if (dayjs(e.date).valueOf() >= dayjs(houseStatus.today).valueOf()) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      visiblePrice: false,
      // 切换渠道房价日历
      handleChangeOtaPrice(e) {
        if (typeof e == 'object' || !e) {
          housePrice.getPriceData();
          return;
        }
        searchLoading.value = true;
        otaGetCale({
          ota_house_id: e,
          begin: dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          end: dayjs().add(12, 'month').startOf('month').format('YYYY-MM-DD'),
        }).then(res => {
          searchLoading.value = false;
          for (let item of res.data) {
            for (let s = item.list[0].week; s > 0; s--) {
              item.list.unshift({
                day: '',
                parice: '',
              });
            }
          }
          housePrice.priceData = res.data;
        });
      },
    });

    // 渠道
    const channel = reactive({
      // 获取已绑定的渠道房间
      bandChannelHouseList: [],
      getBandChannelHouse() {
        otaGetOtaRoomList({
          rid: details.rid,
          type: 1,
        }).then(res => {
          channel.bandChannelHouseList = res.data;
        });
      },
      // 获取未关联的渠道账号
      unBandChannelList: [],
      getunBandChannel() {
        otaGetRelatOtaCom({
          rid: details.rid,
          type: 3,
          status: 1,
        }).then(res => {
          channel.unBandChannelList = res.data.list;
        });
      },
      // 获取未启用的渠道列表
      unUseChannelList: [],
      getunUseChannel() {
        otaGetAllOtaList({
          type: 3,
        }).then(res => {
          channel.unUseChannelList = res.data;
        });
      },

      unBingChannel(item) {
        Modal.confirm({
          title: '确定取消关联？',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            otaDelHouseRela({
              id: item.id,
            }).then(res => {
              message.success(res.msg);
              channel.getBandChannelHouse();
              channel.getunBandChannel();
            });
          },
        });
      },
    });

    onMounted(() => {
      details.getDetailsData();
    });

    return {
      imgCut,
      scollHeigth,
      searchLoading,
      dayjs,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      ...toRefs(details),
      ...toRefs(tab),
      ...toRefs(houseStatus),
      ...toRefs(housePrice),
      ...toRefs(releHouse),
      ...toRefs(channel),
    };
  },
};
</script>

<style lang="scss" scoped>
.price-top {
  margin: 0 10px 5px 10px;
}

.card-box {
  overflow: auto;
  padding: 10px;

  .card-con {
    width: 675px;

    .title {
      margin-bottom: 30px;
      font-weight: bold;
    }

    .operate {
      // border-top: 1px solid #f2f2f2;
      padding: 10px;
      text-align: center;
      // margin-left: 100px;
    }
  }
}

.empty-box {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.channel {
  overflow-y: scroll;

  .status {
    margin: 10px;
  }

  .channel-list {
    display: flex;
    flex-wrap: wrap;

    .channel-list-box {
      margin: 10px;
      padding: 10px 10px 0 10px;
      box-shadow: 0 0 10px #99999955;
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 200px;

      .name {
        // margin-bottom: 10px;
        padding: 10px;
        display: flex;
        align-items: center;

        .logo {
        }

        .channel-name {
          margin-left: 10px;

          .introduce {
            text-align: left;
          }
        }
      }

      .house {
        display: flex;
        align-items: center;
        padding: 10px;
        margin: 10px 0;

        .image {
          margin-right: 10px;
        }

        .info {
          .hname {
          }

          .account {
          }
        }
      }

      .operate {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 60px;
        border-top: 1px solid #f2f2f2;

        .m-l {
          margin-left: 10px;
        }
      }
    }
  }
}

.calendar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-y: scroll;

  .mon-box {
    margin: 10px;
    padding: 15px 3px;
    background-color: #ffffff;
    border-radius: 5px;
    // border: 1px solid #f2f2f2;
    width: calc((100% / 3) - 30px);
    box-shadow: 0 0 6px #99999933;
    height: 530px;

    .month {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .week {
      display: flex;
      justify-content: space-around;
      margin-bottom: 10px;
      text-align: center;
      color: #666666;
      // font-weight: bold;
    }

    .day-box {
      margin-top: 5px;
      padding: auto;
      // width: 100vw;
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      // justify-content: space-between;
      .one-box {
        width: calc(100% / 7);
        display: flex;
        flex-direction: column;
        // background-color: #f5f6f7;
        // margin: 4rpx;
        border-radius: 5px;
        border: 1px solid #ffffff;
        height: 70px;
        justify-content: center;
        position: relative;

        .disabled {
          position: absolute;
          top: -4px;
          right: -4px;
          z-index: 4;
          padding: 4px;
          // height: 35rpx;
          // width: 35rpx;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid #ffffff;
          border-radius: 50%;
        }

        .day {
          text-align: center;
        }

        .order-day {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 70px;
          color: #fff;

          .order-day-one {
            flex: 1;
            // width: calc(100% / 7);
            text-align: center;
          }
        }

        .price {
          text-align: center;
          // font-size: 10px;
        }

        .tips-rig {
          position: absolute;
          color: #00aa00;
          right: 6px;
          top: -2px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .tips-lef {
          position: absolute;
          left: 6px;
          top: -2px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .tips-unusual {
          position: absolute;
          right: 2px;
          top: 25px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          // background-color: #fff;
        }
      }

      .pitchOn {
        background-color: #0094ff !important;
        color: #ffffff;
        background-image: none !important;
        z-index: 99;
      }

      .pitchOnRange {
        background-color: #55aaff !important;
        color: #ffffff;
        background-image: none !important;
        z-index: 99;
      }
    }
  }
}

.start {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-left: 1px solid #ffffff;
}

.end {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-right: 1px solid #ffffff;
}

.pitchOnOrder {
  border-bottom: 2px solid #000000;
  color: #666666 !important;
}

.noClick {
  // background-color: #f3f3f3 !important;
  cursor: not-allowed !important;
  background-image: url(../../../../assets/image/pms_disable.jpg);
  background-size: cover;
}

.lock {
  // border: 1px solid red !important;
  // background-color: #dadada;
  background-image: url(../../../../assets/image/pms_lock.jpg);
  background-size: cover;
}

.hasorder {
  // border: 1px solid red !important;
  // background-color: #dadada;
  background-image: url(../../../../assets/image/pms_order.jpg);
  background-size: cover;
}

.unUsual {
  // border: 1px solid red !important;
  background-color: #dadada;
}

.hoverBox:hover {
  border: 1px solid #666666 !important;
  // box-shadow: 0 0 5px #99999966;
  cursor: pointer;
}

.f999 {
  color: #999999;
}

.page {
  background-color: #fff;

  .goback {
    margin: 0 20px 0 10px;
    height: 50px;
    line-height: 50px;

    .outlined {
    }

    &:hover {
      color: #0094ff;
      cursor: pointer;
    }
  }

  .tabs-card {
    margin: 0 12px;
  }

  .info {
    // margin: 10px;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f7f8fa;
      padding: 20px;
      // height: 140px;
      .image {
        border-radius: 20px;
        position: relative;

        .hint {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          background-color: #00000055;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
        }
      }

      .title {
        flex: 1;
        text-align: left;
        margin: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 70px;

        .editable-cell {
          position: relative;

          .editable-cell-input-wrapper,
          .editable-cell-text-wrapper {
            display: flex;
            align-items: center;
            width: 300px;
          }

          .editable-cell-icon,
          .editable-cell-icon-check {
            cursor: pointer;
            margin-left: 5px;
          }

          .editable-cell-icon:hover,
          .editable-cell-icon-check:hover {
            color: #108ee9;
          }

          .editable-add-btn {
            margin-bottom: 8px;
          }
        }
      }

      .btn {
      }
    }

    .con {
      margin-top: 20px;

      .card-container {
        .card-con {
          overflow: auto;
          padding: 10px;

          .title {
            margin-bottom: 30px;
            font-weight: bold;
          }

          .operate {
            // border-top: 1px solid #f2f2f2;
            padding: 10px;
            text-align: center;
            width: 400px;
          }

          .add-btn {
            text-align: left;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}

.house-list {
  display: flex;
  flex-wrap: wrap;

  .house-one {
    width: 300px;
    display: flex;
    margin: 0 10px 10px 0;
    padding: 10px;
    box-shadow: 0 0 10px #99999933;
    position: relative;

    .house-image {
    }

    .house-name {
      margin-left: 10px;
    }

    .cancel {
      position: absolute;
      right: 4px;
      top: 0px;
      cursor: pointer;
    }
  }
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

:deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab) {
  border-radius: 6px 6px 0 0 !important;
  background-color: #f0f0f0;
  margin-right: 10px;
}

:deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active) {
  background-color: #fff !important;
}

:deep(.ant-tabs-tab) {
  padding: 10px 12px !important;
}
</style>
